import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.authService.user.subscribe(usuario => {
      if (usuario?.token) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${usuario?.token}`
          }
        });
      }
    });

    return next.handle(request);
  }

}
